import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

import bg_logo from '../assets/img/sheep-orange.jpeg';

export default createGlobalStyle`
:root{
  --dark06: #060606;
  --dark70: #707070;
  --green6E: #e84e22  ;
  --green74: #e84e22  ;
  --green44: #e84e22  ;
  --green4F: #e84e22  ;
  /* --green24: #e84e22  ; */
  --green2F: #e84e22  ;

  --green0F: #973925;
  --greyBF: #BFBFBF;
  --grey9E: #9E9E9E;
  --redFE: #FE7171;
  --yellowF8: #F8C845;
  --yellowFF: #FFC270;

  --green00: #e84e22  ;
;  
  --purpleA1: #d06454;

  --purple-gradient:   linear-gradient(
    0deg,
    rgba(232, 78, 34, 0.35898109243697474) 0%,
    rgba(234, 246, 234, 0.09) 10%,
    rgba(255, 252, 252, 0.03) 65%,
    rgba(255, 255, 255, 0) 100%
  );
  --green-gradient: linear-gradient( 0deg, 
    rgba(250,78,32,0.5242471988795518) -10%, 
    rgba(208,100,84,0.3981967787114846) 6%, 
    rgba(234,246,234,0.09) 19%, 
    rgba(255,252,252,0.03) 65%, 
    rgba(255,255,255,0) 100% )

  --green16: #131e23  ;
  --purple84: #e84e22  ;
  --green24: #131e23  ;
  --green2c: #e84e22;

  --blue2c: #e84e22;

  --purple03: #131e23  ;
  --purple93: #d06454;
  --purple6a: #bc341c;
  --purple27: #e84e22  ;

  --light-bg:#f2f4f7;
  --border10: 5px;
  --border20: 5px;

  --purple-gradient:   linear-gradient(
    0deg,
    #e84e22   -10%,
    #e84e22   0%,
    rgba(234, 246, 234, 0.09) 19%,
    rgba(255, 252, 252, 0.03) 65%,
    rgba(255, 255, 255, 0) 100%
  );

  --green-gradient: linear-gradient( 0deg, 
    #e84e22 -10%, 
    #e84e22 6%, 
    rgba(234,246,234,0.09) 19%, 
    rgba(255,252,252,0.03) 65%, 
    rgba(255,255,255,0) 100% );


  --logo-background: linear-gradient(70deg, rgba(255,255,255, .2), rgba(255,255,255, 1), rgba(255,255,255,1), rgba(255,255,255,.2)), url(${bg_logo}) center;
  


}

  * {
    margin: 0;
    padding: 0;
    
    box-sizing: border-box;
    outline-color: transparent !important;
  }

  a {
    text-decoration: none !important;
    color: inherit !important;
  }

  html {
    font-size: 16px;
    color: var(--dark70);


    @media (max-width: 1080px) {
        font-size: 93.75%;
    }

    @media (max-width: 720px) {
      font-size: 87.5%;
    }

    @media (max-width: 561px) {
      font-size: 75%;
    }

    @media (max-width: 520px) {
      font-size: 70%;
    }

    @media (max-width: 460px) {
      font-size: 55%;
    }

    @media (max-width: 380px) {
      font-size: 45%;
    }
  }

  body {

    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;


  }

#root {
  display: flex;
  flex-direction: column;

  min-height: 100vh;
}



    /* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
  border-radius: 30rem;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #131e23;
  border-radius: 30rem;
}

  @keyframes rendering{
    from{
      opacity:0
      }
    to{
        opacity:1
    }
  }

  @keyframes hero_slide{
    from{
      margin-right: -94%;
      }
    to{
      margin-right: 0;
    }
  }
  
`;
